import {Component, EventEmitter, Input, Output} from '@angular/core';

import {GgDropdownComponent, GgDropdownMenuDirective, GgDropdownToggleDirective} from '../../../../../shared/components/gg-dropdown';
import {TranslatePipe} from "@ngx-translate/core";
import {ConfirmDeleteDirective} from "../../../../../shared/directive/confirm-delete.directive";
import {IconComponent} from '../../../../../shared/components/icon/icon.component';

export type ChatAction = 'star' | 'unstar' | 'rename' | 'export' | 'share' | 'delete';

@Component({
    selector: 'app-chat-actions-dropdown',
    imports: [GgDropdownComponent, GgDropdownToggleDirective, GgDropdownMenuDirective, TranslatePipe, ConfirmDeleteDirective, IconComponent],
    templateUrl: './chat-actions-dropdown.component.html',
    styleUrl: './chat-actions-dropdown.component.scss'
})
export class ChatActionsDropdownComponent {
    @Input() isStarred: boolean = false;
    @Input() context: 'header' | 'list' = 'header';
    @Input() title?: string;
    /** null = nevyrenderuj do body (topbar), 'body' = teleportuj do body (sidebar listy) */
    @Input() dropdownContainer: string | null = 'body';
    @Output() actionSelected = new EventEmitter<ChatAction>();

    onActionClick(action: ChatAction): void {
        this.actionSelected.emit(action);
    }
}
